var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M17.702 17.705h-2.399v-3.76c0-.896-.018-2.05-1.25-2.05-1.25 0-1.442.976-1.442 1.985v3.825h-2.399v-7.73h2.304v1.053h.032c.322-.607 1.105-1.248 2.275-1.248 2.43 0 2.88 1.6 2.88 3.682zM7.503 8.918A1.391 1.391 0 0 1 6.345 6.75a1.393 1.393 0 1 1 1.157 2.168zm1.202 8.787H6.3v-7.73h2.406zM18.903 3.9H5.096c-.662 0-1.196.522-1.196 1.167v13.866c0 .645.535 1.167 1.196 1.167H18.9c.66 0 1.2-.522 1.2-1.167V5.067c0-.645-.54-1.167-1.2-1.167z"
  })));
};
export default SvgLinkedin;